import apiClient from './apiClient';

export const superadminApi = {
    // ---- Companies ----
    getCompanies: () => apiClient.get('/api/platform/companies').then(res => res.data),
    createCompany: (data) => apiClient.post('/api/platform/companies', data).then(res => res.data),
    updateCompany: (id, data) => apiClient.put(`/api/platform/companies/${id}`, data).then(res => res.data),
    deleteCompany: (id) => apiClient.delete(`/api/platform/companies/${id}`).then(res => res.data),
    resetCompanyAdmin: (id, data) => apiClient.put(`/api/platform/companies/${id}/reset-admin`, data).then(res => res.data),

    // ---- Company Tools ----
    getCompanyTools: (companyId) => apiClient.get(`/api/platform/companies/${companyId}/tools`).then(res => res.data),
    updateCompanyTool: (companyId, toolKey, data) => apiClient.put(`/api/platform/companies/${companyId}/tools/${toolKey}`, data).then(res => res.data),

    // ---- Users ----
    getCompanyUsers: (companyId) => apiClient.get(`/api/platform/companies/${companyId}/users`).then(res => res.data),
    getUserDetails: (userId) => apiClient.get(`/api/platform/users/${userId}/details`).then(res => res.data),
    updateUser: (userId, data) => apiClient.put(`/api/platform/users/${userId}`, data).then(res => res.data),
    deleteUser: (userId) => apiClient.delete(`/api/platform/users/${userId}`).then(res => res.data),
    updateUserTool: (userId, toolKey, data) => apiClient.put(`/api/platform/users/${userId}/tools/${toolKey}`, data).then(res => res.data),
    forceUserStatus: (userId, data) => apiClient.put(`/api/platform/users/${userId}/force-status`, data).then(res => res.data),
    resetUserPassword: (userId, data) => apiClient.put(`/api/platform/users/${userId}/reset-password`, data).then(res => res.data),
};
